
export const Links = {
   HOME:'/',
   LOGOUT:'/logout',
   CONTACT:'/contact',
   ABOUT:'/about',
   HELP:'/help',
   TERMS:'/terms-and-conditions',
   PRIVACY:'/privacy-policy',
   CHANGE_PASSWORD:'/change-password',
   PROFILE:'/profile',
   USER_LOGIN:'/login',
   USER_SIGNUP:'/register',
   RESET_PASSWORD:'/reset-password',
   COMPANY:'/company',
   BLOG:'/app',
   REGISTRATIONSUCCESS:'/registration-success',
   MYDASHBOARD:'/dashboard',
   HOWITWORK:'/how-it-works',
   FAQ:'/faq',
   SCREENS:'/screens',
   SECTORS:'/sectors',
   IPO:'/ipo',
   INDICES:'/indices',
   FORUM:'/forum',
   MYFORUMS:'/my-forums',
   MYSCREENS:'/my-screens',
   MYFOLLOWEDSCREENS:'/my-followed-screens',
   SMEMARKET:'/sme-stocks',
   SUPERINVESTORS:'/indian-top-investors',
   CONCALLS:'/concalls',
   INVESTOR:'/investor',
   DEMOPORTFOLIO:'/demoportfolio',
   MYSMARTPORTFOLIO:'/my-smart-portfolio',
   STOCKANALYSIS:'know-your-stocks'
}